import Pagination from '@/util/pagination'

export default function () {
  return {
    modalities: [],
    pagination: new Pagination(),
    showDeleteDialog: false,
    deletingId: null,
  }
}
